import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetPositionById } from './position';

export function getUsePositionQueryKey(positionId: string) {
    return ['position', positionId];
}

type QueryOptionsParams = [
    positionId: string,
    {
        fetchOnce?: boolean;
    }?,
];

export const useGetPositionQueryOptions = () => {
    const { getPositionById } = useGetPositionById();

    return (positionId: QueryOptionsParams[0], { fetchOnce = false }: QueryOptionsParams[1] = {}) => ({
        queryKey: getUsePositionQueryKey(positionId),
        queryFn: () => getPositionById(positionId),
        ...(fetchOnce && { staleTime: Infinity, cacheTime: Infinity }),
    });
};

export const usePosition = (...params: QueryOptionsParams) => {
    const getQueryOptions = useGetPositionQueryOptions();
    return useSuspenseQuery(getQueryOptions(...params));
};
